// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bdeaa8b3","455":"034deac5","977":"676e1390"}[chunkId] + ".chunk.js";
};